import { createFileRoute } from "@tanstack/react-router";
import StartHere from "@/pages/StartHere";
export const Route = createFileRoute("/start-here")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Start Here | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Start your depression treatment journey here. Learn about TMS, SAINT TMS, SPRAVATO, and next steps at Neuro Wellness TMS in Coral Springs, FL.",
        },
        {
          property: "og:title",
          content: "Start Here | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Start your depression treatment journey here. Learn about TMS, SAINT TMS, SPRAVATO, and next steps at Neuro Wellness TMS in Coral Springs, FL.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/start-here",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/start-here",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <StartHere />;
}
